import { Package } from "@/components/icons";
import { ProductTypeIcon } from "@/lib/icons/product-icons";
import { cn } from "@/lib/utils";

export function ProductCardPlaceholder({
  productTypeSlug,
  className,
  iconClassName,
}: {
  productTypeSlug?: string | null;
  className?: string;
  iconClassName?: string;
}) {
  const iconClass = cn("size-2/5 max-h-24 text-fg-subtle", iconClassName);
  return (
    <div
      className={cn(
        "flex h-full w-full items-center justify-center bg-surface-2",
        className,
      )}
    >
      <ProductTypeIcon
        slug={productTypeSlug}
        className={iconClass}
        fallback={<Package className={iconClass} aria-hidden />}
      />
    </div>
  );
}
